import React from "react";
import Modal from "./Modal";

export interface UploadNotification {
  id: number;
  team_name: string;
  team_code: string;
  tables_to_create: string[];
  status: string;
}

interface UploadNotificationModalProps {
  isOpen: boolean;
  notifications: UploadNotification[];
  onAcknowledge: () => void;
}

function extractSportName(tableName: string): string {
  if (!tableName) return "";
  const cleaned = tableName.replace(/^足球|^篮球|^棒球/, "");
  const sportMap: Record<string, string> = {
    football: "Football",
    basketball: "Basketball",
    baseball: "Baseball",
    mfb: "Football",
    mbb: "Basketball",
    bsb: "Baseball",
  };
  const lower = cleaned.toLowerCase();
  for (const [key, value] of Object.entries(sportMap)) {
    if (lower.includes(key)) {
      return value;
    }
  }
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).replace(/_/g, " ");
}

const UploadNotificationModal: React.FC<UploadNotificationModalProps> = ({
  isOpen,
  notifications,
  onAcknowledge,
}) => {
  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onAcknowledge}
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEsc={false}
      panelClassName="bg-white p-6 rounded-lg shadow-lg w-[520px] relative"
    >
      <div className="flex flex-col gap-4">
        <div className="text-center">
          <div className="text-4xl mb-2">🎉</div>
          <h2 className="text-xl font-semibold text-gray-900">Good News!</h2>
          <p className="mt-2 text-sm text-gray-700">
            Your recordbook data has been uploaded:
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-md p-4 space-y-3">
          {notifications.map((notification) => {
            const sport = notification.tables_to_create?.[0]
              ? extractSportName(notification.tables_to_create[0])
              : "Recordbook";
            return (
              <div key={notification.id} className="flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-900">
                    Team:
                  </span>
                  <span className="text-sm text-gray-700">
                    {notification.team_name}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-900">
                    Sport:
                  </span>
                  <span className="text-sm text-gray-700">{sport}</span>
                </div>
              </div>
            );
          })}
        </div>

        <p className="text-sm text-gray-600 text-center">
          You can now search and analyze this data.
        </p>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={onAcknowledge}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded"
          >
            Got it!
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadNotificationModal;